export const formatText = (text) => {
    return text?.charAt(0) + text?.slice(1)?.toLowerCase()
}